export default __webpack_public_path__ + "static/media/marking--discrete--arrow--split-right-or-straight.19848277.png";